module.exports = __webpack_public_path__ + "img/18.6b5b3f51.png";